import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {
  SentimentInfoModel,
  SummaryInfoModel,
  TranscriptInfoViewModel,
  TranscriptionInfoViewModel,
} from '../../../api/models';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { TranscriptSentimentIconComponent } from './transcript-sentiment-icon/transcript-sentiment-icon.component';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { TranscriptParagraphComponent } from './transcript-paragraph/transcript-paragraph.component';

export interface TranscriptionInfoDialogData {
  transcriptionInfo: TranscriptionInfoViewModel;
}

@Component({
    selector: 'app-transcription-info-dialog',
    templateUrl: './transcription-info-dialog.component.html',
    styleUrls: ['./transcription-info-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        TranscriptSentimentIconComponent,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        NgFor,
        TranscriptParagraphComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class TranscriptionInfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: TranscriptionInfoDialogData) {}

  get transcriptInfo(): TranscriptInfoViewModel {
    return this.data?.transcriptionInfo?.transcriptInfo;
  }

  get sentimentInfo(): SentimentInfoModel {
    return this.data?.transcriptionInfo?.sentimentInfo;
  }

  get summaryInfo(): SummaryInfoModel {
    return this.data?.transcriptionInfo?.summaryInfo;
  }
}
